// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-window {
  font-size: 17px;
  color: #000000;
  width: 100%;
  height: 25vh;
  padding: 2vh;
  border: 1px solid #DDDDDD;
  border-radius: 2vh;
  resize: none;
  box-sizing: border-box;
}

.input-container {
  display: flex;
  align-items: center;
  width: -webkit-fill-available;
}

.text-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between;
  flex-grow: 1; */
  width: 100%;
  padding: 20px;
}

/* text input */
input[type='text'] {
  font:
    15px/24px 'Muli',
    sans-serif;
  color: white;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}
:focus {
  outline: none;
}
.message-input-container {
  float: left;
  width: 50vw;
  margin: 15px 3%;
  position: relative;
}
input[type='text'] {
  font:
    15px/24px 'Lato',
    Arial,
    sans-serif;
  color: white;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}
.message-input {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 7px 14px 9px;
  transition: 0.4s;
  font-size: 20px;
  display: flex;
  /* color: white; */
  color: #000000 !important;
  background-color: transparent;
}

.message-input ~ .focus-border:before,
.message-input ~ .focus-border:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #85a7ff;
  transition: 0.3s;
}
.message-input ~ .focus-border:after {
  top: auto;
  bottom: 0;
  left: auto;
  right: 0;
}
.message-input ~ .focus-border i:before,
.message-input ~ .focus-border i:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 0;
  background-color: #85a7ff;
  transition: 0.4s;
}
.message-input ~ .focus-border i:after {
  left: auto;
  right: 0;
  top: auto;
  bottom: 0;
}
.message-input:focus ~ .focus-border:before,
.message-input:focus ~ .focus-border:after {
  width: 100%;
  transition: 0.3s;
}
.message-input:focus ~ .focus-border i:before,
.message-input:focus ~ .focus-border i:after {
  height: 100%;
  transition: 0.4s;
}

.options-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 40px;
  bottom: 0;
  width: 100%;
}

.search-checkbox {
  margin-top: 15px;
  color: white;
}

.white {
  color: white;
}

.talk-on {
  color: red;
}

.talk-off {
  color: white;
}

.recording-animation {
  animation: pulsate 1s infinite;
}

@keyframes pulsate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TextView/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;iBACe;EACf,WAAW;EACX,aAAa;AACf;;AAEA,eAAe;AACf;EACE;;cAEY;EACZ,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;;;cAGY;EACZ,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,QAAQ;AACV;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;AACX;AACA;;EAEE,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".chat-window {\n  font-size: 17px;\n  color: #000000;\n  width: 100%;\n  height: 25vh;\n  padding: 2vh;\n  border: 1px solid #DDDDDD;\n  border-radius: 2vh;\n  resize: none;\n  box-sizing: border-box;\n}\n\n.input-container {\n  display: flex;\n  align-items: center;\n  width: -webkit-fill-available;\n}\n\n.text-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* justify-content: space-between;\n  flex-grow: 1; */\n  width: 100%;\n  padding: 20px;\n}\n\n/* text input */\ninput[type='text'] {\n  font:\n    15px/24px 'Muli',\n    sans-serif;\n  color: white;\n  width: 100%;\n  box-sizing: border-box;\n  letter-spacing: 1px;\n}\n:focus {\n  outline: none;\n}\n.message-input-container {\n  float: left;\n  width: 50vw;\n  margin: 15px 3%;\n  position: relative;\n}\ninput[type='text'] {\n  font:\n    15px/24px 'Lato',\n    Arial,\n    sans-serif;\n  color: white;\n  width: 100%;\n  box-sizing: border-box;\n  letter-spacing: 1px;\n}\n.message-input {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 7px 14px 9px;\n  transition: 0.4s;\n  font-size: 20px;\n  display: flex;\n  /* color: white; */\n  color: #000000 !important;\n  background-color: transparent;\n}\n\n.message-input ~ .focus-border:before,\n.message-input ~ .focus-border:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background-color: #85a7ff;\n  transition: 0.3s;\n}\n.message-input ~ .focus-border:after {\n  top: auto;\n  bottom: 0;\n  left: auto;\n  right: 0;\n}\n.message-input ~ .focus-border i:before,\n.message-input ~ .focus-border i:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 2px;\n  height: 0;\n  background-color: #85a7ff;\n  transition: 0.4s;\n}\n.message-input ~ .focus-border i:after {\n  left: auto;\n  right: 0;\n  top: auto;\n  bottom: 0;\n}\n.message-input:focus ~ .focus-border:before,\n.message-input:focus ~ .focus-border:after {\n  width: 100%;\n  transition: 0.3s;\n}\n.message-input:focus ~ .focus-border i:before,\n.message-input:focus ~ .focus-border i:after {\n  height: 100%;\n  transition: 0.4s;\n}\n\n.options-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 40px;\n  bottom: 0;\n  width: 100%;\n}\n\n.search-checkbox {\n  margin-top: 15px;\n  color: white;\n}\n\n.white {\n  color: white;\n}\n\n.talk-on {\n  color: red;\n}\n\n.talk-off {\n  color: white;\n}\n\n.recording-animation {\n  animation: pulsate 1s infinite;\n}\n\n@keyframes pulsate {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
